"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Quote, Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
const testimonials = [{
  author: "Chris Newsom",
  position: "Property Owner, Whitsett",
  quote: "\"Chipper came out and cleared nearly an acre on our flower farm, and did an excellent job.\xA0 Timely, efficient and great guys to work with.\"",
  avatar: "https://optimum-pug.10web.cloud/wp-content/uploads/2026/05/cropped-Chipper_Logo_w_Skid_Steer_TANSBG_Small-1.png?v=h3lz0ox5n05"
}, {
  author: "Sarah Jenkins",
  position: "Real Estate Developer",
  quote: "Professional, fast, and surprisingly low-impact. They turned an overgrown lot into a prime building site without damaging our mature oaks.",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/sarah_jenkins_developer.png"
}, {
  author: "David Thompson",
  position: "Homeowner",
  quote: "The team was energetic and clearly knew their stuff. Our new trail system is exactly what we wanted. Best landscaping investment yet!",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/david_thompson_homeowner.png"
}];
export default function VoicesOfSuccess() {
  return <section data-section-id="221605" id="what-our-neighbors-say" className="bg-background text-foreground relative py-24 md:py-32 overflow-hidden">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        {}
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678813/img/forest_trail_texture.png)] opacity-10 bg-cover bg-center animate-[pulse_12s_ease-in-out_infinite]" />
        {}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80vw] h-[80vw] max-w-[1000px] max-h-[1000px] bg-secondary/5 rounded-lg blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-5xl mx-auto">
          <Carousel opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                  <div className="flex flex-col items-center text-center px-4 md:px-16 py-8 bg-secondary rounded-2xl shadow-xl border border-secondary/20">
                    {}
                    <Quote className="size-12 md:size-16 text-primary mb-8 rotate-180 opacity-90" />

                    {}
                    <p className="text-xl md:text-2xl font-default italic text-secondary-foreground leading-relaxed mb-10 max-w-4xl">
                      "{testimonial.quote}"
                    </p>

                    {}
                    <div className="flex items-center justify-center gap-1.5 mb-8">
                      {[...Array(5)].map((_, starIdx) => <Star key={starIdx} data-index={starIdx} className="size-5 md:size-6 fill-primary text-primary" />)}
                    </div>

                    {}
                    <div className="flex flex-col items-center">
                      <SafeHydrate><Avatar className="size-20 mb-5 ring-4 ring-primary ring-offset-4 ring-offset-secondary shadow-lg">
                        <AvatarImage src={testimonial.avatar} alt={testimonial.author} className="object-cover" />
                        <AvatarFallback className="text-xl font-default bg-muted text-muted-foreground">
                          {testimonial.author.charAt(0)}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      <h3 className="text-lg md:text-xl font-default font-bold text-secondary-foreground">
                        {testimonial.author}
                      </h3>
                      <p className="text-sm md:text-base font-default text-secondary-foreground/80 mt-1">
                        {testimonial.position}
                      </p>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            {}
            <div className="hidden md:block">
              <CarouselPrevious className="left-0 xl:-left-12 bg-card/80 backdrop-blur-md border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all size-12 rounded-lg shadow-md" />
              <CarouselNext className="right-0 xl:-right-12 bg-card/80 backdrop-blur-md border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all size-12 rounded-lg shadow-md" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}